/**
 * Kenlo Provider (ex-ValueGaia)
 * Plataforma de gestão imobiliária via feed XML
 */

import type { DatabaseProvider } from '../types';

export const kenloProvider: DatabaseProvider = {
  id: 'database-kenlo',
  name: 'Kenlo',
  description: 'Plataforma de gestão imobiliária (ex-ValueGaia)',
  type: 'properties',
  color: '#f59e0b', // amber-500
  icon: 'home',
  authFields: [
    {
      name: 'apiToken',
      type: 'url',
      label: 'URL do Feed XML *',
      placeholder: 'Cole aqui a URL do feed XML do Kenlo',
      required: true,
      helpText: 'URL completa do feed XML fornecida pelo Kenlo/ValueGaia (ex: https://imob.valuegaia.com.br/integra/midia.ashx?...)',
    },
  ],
  isAvailable: true,
};
